import React, { Component, Fragment } from "react";
import axios from "axios";
import { renderToStaticMarkup } from "react-dom/server";
import { withLocalize } from "react-localize-redux";
import { Link } from "react-router-dom";
import globalTranslations from "../../translations/global.json";
import { Login, LanguageToggle } from "../index";
import { Translate } from "react-localize-redux";

const storeId = process.env.REACT_APP_STOREID;
const base_services_api = process.env.REACT_APP_SERVICES_API_BASE;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscription: false,
    };

    if (typeof window !== "undefined") {
      this._prevPath = window.location.pathname;
    } else {
      this._prevPath = "";
    }

    const languages = [
      { name: "English", code: "en" },
      { name: "Mongolian", code: "mn" },
    ];

    /* Өгөгдмөл хэл — үргэлж монгол. Зөвхөн хаягийн query-д хэл ирвэл
       (?lang=en, ?language=en, ?lng=en) түүнийг ашиглана. */
    const defaultLanguage = this.languageFromQuery(languages) || "mn";

    this.props.initialize({
      languages,
      translation: globalTranslations,
      options: {
        renderToStaticMarkup,
        defaultLanguage,
      },
    });
  }

  languageFromQuery = (languages) => {
    if (typeof window === "undefined") return null;
    const params = new URLSearchParams(window.location.search);
    const raw = (params.get("lang") || params.get("language") || params.get("lng") || "")
      .trim()
      .toLowerCase();
    if (!raw) return null;
    const aliases = { eng: "en", english: "en", mon: "mn", mongolian: "mn" };
    const code = aliases[raw] || raw;
    return languages.some((l) => l.code === code) ? code : null;
  };

  componentDidMount() {
    this.auth = this.props.auth;

    if (this.auth.isAuthenticated()) {
      axios
        .get(`${base_services_api}/users/${this.props.auth.authData.sub}/profile`, {
          headers: {
            StoreId: storeId,
            Authorization: `Bearer ${this.props.auth.authData.access_token}`,
          },
        })
        .then((resp) => {
          if (resp.data.Subscriptions[0]) {
            this.setState({
              subscription: true,
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // Auto logout on 401 Unauthorized
            localStorage.clear();
            sessionStorage.clear();
            this.props.auth.logout();
          }
        });
    }
  }

  componentDidUpdate(prevProps) {
    const prevLangCode = prevProps.activeLanguage && prevProps.activeLanguage.code;
    const curLangCode = this.props.activeLanguage && this.props.activeLanguage.code;

    const hasLanguageChanged = prevLangCode !== curLangCode;

    if (hasLanguageChanged) {
      window.localStorage.setItem("languageCode", curLangCode);
    }

    // If the route changed and we previously set a silentLogin flag, clear it when leaving premium
    if (typeof window !== "undefined") {
      const curPath = window.location.pathname;
      if (this._prevPath !== curPath) {
        // if we left the premium page, remove the silentLogin flag
        const silent = window.localStorage.getItem("silentLogin") === "true";
        if (silent && curPath.indexOf("/premium") === -1) {
          window.localStorage.removeItem("silentLogin");
        }
        this._prevPath = curPath;
      }
    }
  }

  render() {
    const { subscription } = this.state;

    if (typeof window !== "undefined") {
      const silent = window.localStorage.getItem("silentLogin") === "true";
      const onPremium =
        window.location.pathname && window.location.pathname === "/premium";
      if (silent && onPremium) return null;
      const isMymobiPage =
        window.location.pathname === "/sonsy/mymobi" ||
        window.location.pathname === "/mobi/newyear" ||
        window.location.pathname === "/app" ||
        window.location.pathname === "/contents/showlink";
      if (isMymobiPage) return null;
    }

    return (
      <>
        <div className="language">
          <div className="container">
            <LanguageToggle />
          </div>
        </div>
        <header>
          <div className="container-fluid">
            <div className="header-content">
              <div className="logo">
                <a href="/" className="">
                  <img src="/img/logo.png" alt="" />
                </a>
              </div>

              <div className="nav-group">
                <nav className="nav-desktop">
                  {!subscription && (
                    <Link to="/premium">
                      <img className="premium-icon" src="/img/premium_icon.png" alt="Premium" />
                      <Translate id="nav.premium" />
                    </Link>
                  )}
                </nav>
                <div className="sep-line">|</div>
                <Login auth={this.props.auth} btnClassName="nav-btn" />
              </div>
              {/* <MobileNav
                pageWrapId={"page-content"}
                outerContainerId={"App"}
                auth={this.props.auth}
              /> */}
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default withLocalize(Header);
